import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "MaterialEditorViewContainer bothCenter"
};
const _hoisted_2 = {
  class: "editor"
};
const _hoisted_3 = {
  class: "ml16 leftCenter"
};
const _hoisted_4 = {
  class: "ml16 leftCenter"
};
const _hoisted_5 = {
  class: "ml16 leftCenter"
};
const _hoisted_6 = {
  class: "ml16 leftCenter"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_ButtonDialog = _resolveComponent("ButtonDialog");
  const _component_Setting = _resolveComponent("Setting");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Toolbar = _resolveComponent("Toolbar");
  const _component_Editor = _resolveComponent("Editor");
  const _component_IceOssUploader = _resolveComponent("IceOssUploader");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 3,
      class: "leftCenter"
    }, {
      default: _withCtx(() => _cache[12] || (_cache[12] = [_createElementVNode("span", null, "标题", -1), _createElementVNode("span", {
        class: "redDot"
      }, "*", -1)])),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 21,
      class: "rightCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        placeholder: "请输入",
        modelValue: $data.material.title,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.material.title = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter mt16"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 3,
      class: "leftCenter"
    }, {
      default: _withCtx(() => _cache[13] || (_cache[13] = [_createElementVNode("span", null, "业务域", -1), _createElementVNode("span", {
        class: "redDot"
      }, "*", -1)])),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 21,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.material.scopeId,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.material.scopeId = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.params.scopes, b => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: `scope${b.id}`,
            value: b.id,
            label: b.label
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(b.label), 1)]),
            _: 2
          }, 1032, ["value", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_ButtonDialog, {
        "btn-id": 5,
        "btn-name": "新增",
        size: "small",
        onFresh: $options.init
      }, null, 8, ["onFresh"]), _createVNode(_component_el_icon, {
        class: "ml16 ptr",
        color: "#409eff",
        onClick: _cache[2] || (_cache[2] = $event => $options.gotoEnum('SCOPE'))
      }, {
        default: _withCtx(() => [_createVNode(_component_Setting)]),
        _: 1
      })])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter mt16"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 3,
      class: "leftCenter"
    }, {
      default: _withCtx(() => _cache[14] || (_cache[14] = [_createElementVNode("span", null, "业务分类", -1), _createElementVNode("span", {
        class: "redDot"
      }, "*", -1)])),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 21,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.material.bizId,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.material.bizId = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.params.bizTypes, b => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: `biz${b.id}`,
            value: b.id,
            label: b.label
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(b.label), 1)]),
            _: 2
          }, 1032, ["value", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_ButtonDialog, {
        "btn-id": 1,
        "btn-name": "新增",
        size: "small",
        onFresh: $options.init
      }, null, 8, ["onFresh"]), _createVNode(_component_el_icon, {
        class: "ml16 ptr",
        color: "#409eff",
        onClick: _cache[4] || (_cache[4] = $event => $options.gotoEnum('BIZ_TYPE'))
      }, {
        default: _withCtx(() => [_createVNode(_component_Setting)]),
        _: 1
      })])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter mt16"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 3,
      class: "leftCenter"
    }, {
      default: _withCtx(() => _cache[15] || (_cache[15] = [_createElementVNode("span", null, "平台", -1), _createElementVNode("span", {
        class: "redDot"
      }, "*", -1)])),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 21,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.material.platformId,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.material.platformId = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.params.platforms, b => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: `biz${b.id}`,
            value: b.id,
            label: b.label
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(b.label), 1)]),
            _: 2
          }, 1032, ["value", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_ButtonDialog, {
        "btn-id": 2,
        "btn-name": "新增",
        size: "small",
        onFresh: $options.init
      }, null, 8, ["onFresh"]), _createVNode(_component_el_icon, {
        class: "ml16 ptr",
        color: "#409eff",
        onClick: _cache[6] || (_cache[6] = $event => $options.gotoEnum('PLATFORM'))
      }, {
        default: _withCtx(() => [_createVNode(_component_Setting)]),
        _: 1
      })])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt16"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 3
    }, {
      default: _withCtx(() => _cache[16] || (_cache[16] = [_createElementVNode("span", null, "链接", -1)])),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 21
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        type: "textarea",
        placeholder: "例：XX发布了一篇小红书笔记，快来看吧！ 😆 123456 😆 http://xxxxx，复制本条信息...",
        modelValue: $data.material.links,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.material.links = $event),
        rows: "10"
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt16"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 3
    }, {
      default: _withCtx(() => _cache[17] || (_cache[17] = [_createElementVNode("span", null, "文案内容", -1), _createElementVNode("span", {
        class: "redDot"
      }, "*", -1)])),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 21,
      class: "colFlex",
      style: {
        "height": "500px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_Toolbar, {
        style: {
          "border-bottom": "1px solid #ccc"
        },
        editor: $data.editorRef,
        defaultConfig: $data.toolbarConfig,
        mode: "default"
      }, null, 8, ["editor", "defaultConfig"]), _createVNode(_component_Editor, {
        style: {
          "max-height": "500px",
          "overflow-y": "scroll",
          "border": "1px solid lightgrey"
        },
        modelValue: $data.material.content,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.material.content = $event),
        defaultConfig: $data.editorConfig,
        mode: "simple",
        onOnCreated: $options.handleCreated,
        onClick: $options.onEditorFocus
      }, null, 8, ["modelValue", "defaultConfig", "onOnCreated", "onClick"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt16"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 3
    }, {
      default: _withCtx(() => _cache[18] || (_cache[18] = [_createElementVNode("span", null, "多媒体", -1)])),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 21
    }, {
      default: _withCtx(() => [_createVNode(_component_IceOssUploader, {
        key: "medias",
        onOnUploaded: $options.onUploaded,
        fileList: $data.medias
      }, null, 8, ["onOnUploaded", "fileList"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt16"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 3
    }, {
      default: _withCtx(() => _cache[19] || (_cache[19] = [_createElementVNode("span", null, "原始素材(PSD等)", -1)])),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 21,
      class: "colFlex"
    }, {
      default: _withCtx(() => [_createVNode(_component_IceOssUploader, {
        key: "sourceFiles",
        onOnUploaded: $options.onSourceFilesUploaded,
        fileList: $data.sourceFiles
      }, null, 8, ["onOnUploaded", "fileList"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt16"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 3
    }, {
      default: _withCtx(() => _cache[20] || (_cache[20] = [_createElementVNode("span", null, "标签", -1)])),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 21,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        multiple: "",
        modelValue: $data.material.tags,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.material.tags = $event),
        filterable: "",
        style: {
          "width": "800px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.params.tags, b => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: `biz${b.id}`,
            value: b.label,
            label: b.label
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(b.label), 1)]),
            _: 2
          }, 1032, ["value", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_ButtonDialog, {
        "btn-id": 3,
        "btn-name": "新增",
        size: "small",
        onFresh: $options.init
      }, null, 8, ["onFresh"]), _createVNode(_component_el_icon, {
        class: "ml16 ptr",
        color: "#409eff",
        onClick: _cache[10] || (_cache[10] = $event => $options.gotoEnum('MATERIAL_TAG'))
      }, {
        default: _withCtx(() => [_createVNode(_component_Setting)]),
        _: 1
      })])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt16"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 3
    }, {
      default: _withCtx(() => _cache[21] || (_cache[21] = [_createElementVNode("span", null, "爆款", -1)])),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 21
    }, {
      default: _withCtx(() => [_createVNode(_component_el_switch, {
        modelValue: $data.material.boom,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.material.boom = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "rightCenter"
  }, {
    default: _withCtx(() => [$data.material.id != null ? (_openBlock(), _createBlock(_component_el_popconfirm, {
      key: 0,
      title: "确定删除吗",
      onConfirm: $options.deleteMaterial
    }, {
      reference: _withCtx(() => [_createVNode(_component_el_button, {
        type: "danger",
        size: "large"
      }, {
        default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode("删除")])),
        _: 1
      })]),
      _: 1
    }, 8, ["onConfirm"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
      type: "primary",
      size: "large",
      style: {
        "width": "200px"
      },
      onClick: $options.submit
    }, {
      default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("提交")])),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  })])]);
}